import { InteractionStatus } from '@azure/msal-browser';

export const useAuthStatus = (inProgress: InteractionStatus) => {
  return (
    inProgress === InteractionStatus.Startup ||
    inProgress === InteractionStatus.HandleRedirect ||
    inProgress === InteractionStatus.Login
  );
};
